import React from 'react';

import NewsletterPreview from '../../components/Communication/NewsletterPreview';

function NewslettersPreviewView() {
  return (
    <NewsletterPreview />
  );
}

export default NewslettersPreviewView;
